module.exports = __webpack_public_path__ + "static/media/icon-packup.f19bb064.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-packup.svg
// module id = 930
// module chunks = 0